import { useEffect } from "react";
import AddEditAuthorizedIP from "./components/AddEdit/AddEditAuthorizedIP";
import AuthorizedIPTable from "./components/List/AuthorizedIPTable";
import { useAppSelector } from "../../Redux/hooks";
// import Header from "./components/Header"
import Hooks from "./utils/hooks";
import LoadingScreen from "../LoadingScreen";
import NotFound from "../NotFound";
import { getUserData } from "../../userData/action";
import { useDispatch } from "react-redux";
import './AuthorizedIP.scss'
import { Loader } from "@empreinte/components.loader";
import HeaderIp from "./components/Header";

const AuthorizedIP = () => {
 const {formAddAuthorizedIP}=Hooks()
const showDivCondition =useAppSelector((state:any) =>state.AuthorizedIPReducer.showDivsConditionsAuthorizedIP)
const loadingscreen = useAppSelector((state)=>state.ReducerUserData.loading_screen)
const unauthorizedUser = useAppSelector((state)=>state.ReducerUserData.unauthorizedUser)
const loader = showDivCondition.loader
const values = useAppSelector((state)=>state.AuthorizedIPReducer.addAuthorizedIPConstraintsData)

const dispatch = useDispatch();
const { editAuthorizedIP, addAuthorizedIP } = useAppSelector(
  (states) =>
   states.AuthorizedIPReducer.showDivsConditionsAuthorizedIP
);
useEffect(() => {
  dispatch(getUserData());
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);
useEffect(() => {
  if (editAuthorizedIP) {
    formAddAuthorizedIP.setFieldsValue({
      id: values?.id,
      ip: values?.ip,
      description: values?.description,
    });
  }
  if (addAuthorizedIP) {
    formAddAuthorizedIP.resetFields();
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [editAuthorizedIP, addAuthorizedIP]);


if (loadingscreen) {
  return <LoadingScreen/>
} 
else if (unauthorizedUser) {
  return <NotFound/>
}

  return (
     <div className={"divGlobalTable_AuthorizedIp"}>
      <Loader isOpen={loader}/>
  {!showDivCondition.addAuthorizedIP && !showDivCondition.editAuthorizedIP ? (
    <div>
      <HeaderIp/>
      <AuthorizedIPTable />
    </div>
  ) : (
    <div>
        <HeaderIp/>
        <AddEditAuthorizedIP />

     </div>
  )
}
  
  </div>
  )
}
export default AuthorizedIP
